<template>
  <div class="row">
    <div class="col">Pool_ID:{{ pool_id }}</div>
  </div>

  <div class="container">
    <div class="row">
      <div class="col-2" v-for="p in unsold_players" :key="p.id">
        <FlashPlayer :player="p"></FlashPlayer>
      </div>
    </div>
  </div>
</template>
<script setup>
import supabase from "@/supabase/config";
import { defineProps, onMounted, ref, computed } from "vue";
import { useStore } from "@/store/index";
import FlashPlayer from "./FlashPlayer.vue";
const props = defineProps(["pool_id"]);
const pool_id = ref("");
const p_list = ref([]);
const store = useStore();
onMounted(() => {
  pool_id.value = props.pool_id;
  setTimeout(() => {
    fetchPoolList();
  });
});
const fetchPoolList = async () => {
  let { data: pool_list, error } = await supabase
    .from("pool_list")
    .select("*")
    .eq("pool_id", pool_id.value);
  p_list.value = pool_list;
};
const unsold_players = computed(() => {
  var arr = [];
  store.unsold_players.forEach((u) => {
    if (u.pool_id == pool_id.value) {
      arr.push(u);
    }
  });
  return arr;
});
</script>
<style scoped>
.col-2 {
  padding: 2px;
}
</style>
